export enum ServiceNameEnum {
    COMMERCE_SERVICE = "commerce-service",
    PRODUCT_SERVICE = "product-service",
    CART_SERVICE = "cart-service",
    LIVE_STREAMS_SERVICE = "LIVE_STREAMS",
    CMS_STRAPI_SERVICE = "CMS_STRAPI_SERVICE",
    AUTH_SERVICE = "AUTH_SERVICE",
  }
  
  